import { createSelector } from "reselect";
import { ApplicationStore } from "src/store";

export const isLockedPricingExperimentEnabled = (state: ApplicationStore): boolean =>
    !!state?.deal?.experiments?.locked;

export const getDealExperiments = (state: ApplicationStore) => state?.deal?.experiments;

export const getAvailableDealExperiments = createSelector([getDealExperiments], (experiments): string =>
    Object.keys(experiments ?? {}).join("|")
);

export const getEnabledDealExperiments = createSelector([getDealExperiments], (experiments): string =>
    Object.entries(experiments ?? {})
        .reduce((enabled: string[], [key, value]) => (value ? enabled.concat(key) : enabled), [])
        .join("|")
);
